import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { UtilCommonModule } from 'common/util/module'
import { AngularJSComponent } from './components/angularJS.component'

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([]),
    UtilCommonModule,
  ],
  declarations: [
    AngularJSComponent,
  ],
  exports: [
    AngularJSComponent,
  ],
})
export class AngularJSModule { }

export { LazyLoaderService } from './services/lazyLoader.service'
export { AngularJSComponent }
